<footer class="footer">
  <div class="footer-content">
    <div class="footer-main">
      <div class="footer-products">
        <img src="assets/icons/rocket-logo.svg" alt="Rocket Logo" class="rocket-logo" />
        <div class="products-list">
          @for (product of rocketProducts; track product.titleKey) {
            <div class="product-item">
              <a [href]="product.url" class="product-title-link" target="_blank" rel="noopener noreferrer">
                <h3 class="product-title">{{ product.titleKey | translate }}</h3>
              </a>
              <p class="product-description">{{ product.descriptionKey | translate }}</p>
            </div>
          }
        </div>
      </div>

      <div class="footer-links">
        <div class="links-column">
          <h3 class="column-title">{{ 'footer.ROCKET_CLOSE_HEADING' | translate }}</h3>
          <ul class="links-list">
            @for (link of rocketCloseLinks; track link.url) {
              <li>
                <a [href]="link.url" class="footer-link" target="_blank" rel="noopener noreferrer">
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">{{ 'footer.LEGAL_HEADING' | translate }}</h3>
          <ul class="links-list">
            @for (link of legalLinks; track link.url) {
              <li>
                <a [href]="link.url" class="footer-link" target="_blank" rel="noopener noreferrer">
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">{{ 'footer.SUPPORT_HEADING' | translate }}</h3>
          <ul class="links-list">
            @for (link of supportLinks; track link.url) {
              <li>
                <a [href]="link.url" class="footer-link" target="_blank" rel="noopener noreferrer">
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="social-links">
        @for (social of socialLinks; track social.name) {
          <a
            [href]="social.url"
            class="social-link"
            [attr.aria-label]="social.name"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img [src]="social.icon" [alt]="social.name" class="social-icon" />
          </a>
        }
      </div>

      <div class="app-downloads">
        <a
          href="https://apps.apple.com/us/app/rocket-mortgage/id431156417"
          target="_blank"
          rel="noopener noreferrer"
          class="app-badge"
          aria-label="Download on the App Store"
        >
          <img src="assets/icons/apple-store-logo.svg" alt="Download on the App Store" class="app-store-logo" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?hl=en_US&id=com.quickenloans.myql"
          target="_blank"
          rel="noopener noreferrer"
          class="app-badge"
          aria-label="Get it on Google Play"
        >
          <img src="assets/icons/google-store-logo.svg" alt="Get it on Google Play" class="app-store-logo" />
        </a>
      </div>
    </div>
  </div>

  <div class="footer-divider"></div>

  <div class="footer-legal">
    <div class="legal-content">
      <p class="copyright-text">{{ 'footer.COPYRIGHT' | translate: { year: currentYear } }}</p>
      <p class="copyright-text">{{ 'footer.COPYRIGHT_LONG' | translate }}</p>
      <img src="assets/icons/EHO.svg" alt="Equal Housing Opportunity" class="legal-logo" />
    </div>
  </div>
</footer>
